/* Compacte variantkeuze voor producten met veel uitvoeringen. */
(function () {
  'use strict';

  function selectedOptions(picker) {
    return Array.prototype.map.call(
      picker.querySelectorAll('.variant-group'),
      function (group) {
        var select = group.querySelector('[data-variant-compact-select]');
        if (select) return select.value;
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      }
    );
  }

  function findVariant(variants, options) {
    return variants.filter(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    })[0];
  }

  function ensureMobileVariant(section) {
    var price = section && section.querySelector('.product-mobile-buybar__price');
    if (!price) return null;
    var label = price.querySelector('[data-buybar-variant]');
    if (!label) {
      label = document.createElement('span');
      label.className = 'product-mobile-buybar__variant';
      label.setAttribute('data-buybar-variant', '');
      price.appendChild(label);
    }
    return label;
  }

  function init(picker) {
    if (picker.hasAttribute('data-variant-selector-ready')) return;
    picker.setAttribute('data-variant-selector-ready', '');

    var json = picker.querySelector('[data-variants-json]');
    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    var section = picker.closest('section');
    var summaryValue = picker.querySelector('[data-variant-choice-value]');
    var summaryStock = picker.querySelector('[data-variant-choice-stock]');
    var mobileVariant = ensureMobileVariant(section);
    var addLabel = picker.getAttribute('data-add-label') || 'In winkelwagen';
    var inStockLabel = picker.getAttribute('data-in-stock-label') || 'Op voorraad';
    var soldOutLabel = picker.getAttribute('data-sold-out-label') || 'Tijdelijk uitverkocht';
    var unavailableLabel = picker.getAttribute('data-unavailable-label') || 'Deze combinatie is niet beschikbaar';
    var addButtons = section
      ? section.querySelectorAll('[data-product-form] button[type="submit"], [data-buybar-add]')
      : [];
    var deliveryDetails = section && section.querySelector('[data-product-delivery]');

    function setPurchaseAvailability(isAvailable, label) {
      Array.prototype.forEach.call(addButtons, function (button) {
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        button.textContent = label;
      });
      if (deliveryDetails) deliveryDetails.hidden = !isAvailable;
    }

    function refresh() {
      var options = selectedOptions(picker);
      var variant = findVariant(variants, options);
      if (!variant) {
        var unavailableDescription = options.filter(Boolean).join(' / ');
        if (summaryValue) summaryValue.textContent = unavailableDescription;
        if (summaryStock) {
          summaryStock.textContent = unavailableLabel;
          summaryStock.setAttribute('data-available', 'false');
        }
        if (mobileVariant) {
          mobileVariant.textContent = unavailableDescription;
          mobileVariant.hidden = !unavailableDescription;
        }
        setPurchaseAvailability(false, unavailableLabel);
        return;
      }

      var description = variant.options.join(' / ');
      var isDefault = description === 'Default Title';

      if (summaryValue) summaryValue.textContent = description;
      if (summaryStock) {
        summaryStock.textContent = variant.available ? inStockLabel : soldOutLabel;
        summaryStock.setAttribute('data-available', variant.available ? 'true' : 'false');
      }
      if (mobileVariant) {
        mobileVariant.textContent = isDefault ? '' : description;
        mobileVariant.hidden = isDefault;
      }
      setPurchaseAvailability(variant.available, variant.available ? addLabel : soldOutLabel);
    }

    picker.querySelectorAll('[data-variant-compact-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var group = select.closest('.variant-group');
        var radios = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
        var proxy = radios.filter(function (radio) { return radio.value === select.value; })[0];
        if (!proxy) return;
        proxy.checked = true;
        proxy.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    picker.addEventListener('change', refresh);
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-variant-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
